module.exports = __webpack_public_path__ + "assets/img/two-tab1-on.95da45fe.png";